<template>
  <v-col v-if="bpJsonStatus" cols="auto" class="pa-0 mr-3">
    <v-chip
      outlined
      label
      style="height: 36px; background-color: white !important"
      :style="{ 'border-color': chipColor, color: chipColor }"
      class="cursor-pointer"
      @click="goToJsonStatus"
    >
      <v-icon
        left
        small
        class="mr-1"
        :color="chipColor"
        style="margin-left: -2px"
        >{{ statusIcon }}</v-icon
      >
      <span style="font-weight: 400">
        BP.json{{
          !compact && statusText !== 'OK' ? ': ' + detailedStatus : ''
        }}
      </span>
    </v-chip>
  </v-col>
</template>

<script>
import { formatChainMetricValue } from '@/services/chainMetricService';
import { mapGetters } from 'vuex';

export default {
  props: {
    chain: {
      type: Object,
      default: () => ({}),
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['getChainMetric']),
    bpJsonStatus() {
      if (this.chain) {
        return this.getChainMetric(this.chain.id, 'Chain/BpJsonStatus');
      } else {
        return '';
      }
    },
    statusText() {
      if (!this.bpJsonStatus) return 'Loading';
      return formatChainMetricValue('Chain/BpJsonStatus', this.bpJsonStatus)
        .short;
    },
    detailedStatus() {
      if (!this.bpJsonStatus) return '';
      return formatChainMetricValue('Chain/BpJsonStatus', this.bpJsonStatus)
        .long;
    },
    chipColor() {
      switch (this.statusText) {
        case 'OK':
          return 'hsl(120, 67%, 39%)'; // Green
        case 'Error':
          return 'hsl(0, 87%, 59%)'; // Red
        default:
          return 'hsl(0, 0%, 59%)'; // Grey
      }
    },
    statusIcon() {
      switch (this.statusText) {
        case 'OK':
          return 'mdi-check-circle-outline';
        case 'Error':
          return 'mdi-alert-circle-outline';
        default:
          return 'mdi-help-circle-outline';
      }
    },
  },
  methods: {
    goToJsonStatus() {
      this.$router.push('/json-status');
    },
  },
};
</script>
